import { useState } from "react";
import { navLinks, tickerItems } from "@/mocks/gossip";

export default function TopNav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full overflow-hidden border-b border-primary-600/30 bg-primary-700">
        <div className="flex items-center gap-6 py-2">
          <span className="ml-4 hidden shrink-0 items-center gap-2 rounded-full bg-background-50/15 px-3 py-0.5 text-[11px] font-semibold tracking-wide text-background-50 md:inline-flex">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-300 anim-pulse-dot" />
            瓜田速报
          </span>
          <div className="flex min-w-full shrink-0 items-center gap-10 whitespace-nowrap anim-marquee">
            {[...tickerItems, ...tickerItems].map((item, i) => (
              <span key={`${item}-${i}`} className="text-xs text-background-100/90">
                <i className="ri-fire-line mr-1.5 text-accent-300" />
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      <nav className="w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 w-full items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
          <a href="#top" className="flex shrink-0 items-center gap-3 cursor-pointer">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 font-heading text-lg font-black text-background-50 md:h-11 md:w-11">
              瓜
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-base font-black text-foreground-950 md:text-lg">
                骚女qq
              </span>
              <span className="block text-[10px] tracking-[0.22em] text-foreground-500 md:text-[11px]">
                MELON FILE
              </span>
            </span>
          </a>

          <div className="hidden items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
          </div>

          <div className="flex items-center gap-2 md:gap-3">
            <label className="hidden items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 text-sm text-foreground-500 xl:flex">
              <i className="ri-search-line text-base" />
              <input
                type="text"
                placeholder="搜索话题 / 关键词"
                className="w-36 bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </label>
            <a
              href="#subscribe"
              className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
            >
              <i className="ri-notification-3-line" />
              订阅快讯
            </a>
            <button
              type="button"
              aria-label="打开菜单"
              onClick={() => setMenuOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
            >
              <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
            </button>
          </div>
        </div>

        {menuOpen ? (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
            <div className="flex flex-col">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={() => setMenuOpen(false)}
                  className="flex items-center justify-between border-b border-background-100 py-3 text-sm font-medium text-foreground-800"
                >
                  {link.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                </a>
              ))}
              <a
                href="#subscribe"
                onClick={() => setMenuOpen(false)}
                className="mt-3 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
              >
                <i className="ri-notification-3-line" />
                订阅瓜田快讯
              </a>
            </div>
          </div>
        ) : null}
      </nav>
    </header>
  );
}